import { Globals } from "../CoreApp/Globals";

export function CompareScoreDistance(a, b) {
  var a_dist =
    a.fScore > Globals._targetScore
      ? 1.5 * (a.fScore - Globals._targetScore)
      : Globals._targetScore - a.fScore;
  var b_dist =
    b.fScore > Globals._targetScore
      ? 1.5 * (b.fScore - Globals._targetScore)
      : Globals._targetScore - b.fScore;

  return a_dist - b_dist;
}
